import { createStore } from 'redux';

import { PayeeContactTabsType } from '@/legacy/services/filters/payeeFilters';

import ContactsTableState, { getInitialState } from './contactsTable.state';

enum StoreActionType {
  SetState,
  AddSupplierSuccess,
  AddCustomerSuccess,
  Reset,
}

interface SetStateAction {
  readonly type: StoreActionType.SetState;
  readonly payload: { contactType: PayeeContactTabsType; newState: ContactsTableState };
}

interface AddSupplierSuccessAction {
  readonly type: StoreActionType.AddSupplierSuccess;
}

interface AddCustomerSuccessAction {
  readonly type: StoreActionType.AddCustomerSuccess;
}

interface ResetAction {
  readonly type: StoreActionType.Reset;
}

type StoreAction =
  | SetStateAction
  | AddSupplierSuccessAction
  | AddCustomerSuccessAction
  | ResetAction;

interface State {
  [PayeeContactTabsType.All]: ContactsTableState;
  [PayeeContactTabsType.Suppliers]: ContactsTableState;
  [PayeeContactTabsType.Customers]: ContactsTableState;
}

const initialState: State = {
  [PayeeContactTabsType.All]: getInitialState(PayeeContactTabsType.All),
  [PayeeContactTabsType.Suppliers]: getInitialState(PayeeContactTabsType.Suppliers),
  [PayeeContactTabsType.Customers]: getInitialState(PayeeContactTabsType.Customers),
};

const reducer = (state: State, action: StoreAction): State => {
  switch (action.type) {
    case StoreActionType.SetState: {
      const { contactType, newState } = action.payload;
      return {
        ...state,
        [contactType]: newState,
      };
    }
    case StoreActionType.AddSupplierSuccess:
      return {
        ...state,
        [PayeeContactTabsType.All]: {
          ...state[PayeeContactTabsType.All],
          grandTotalCount:
            state[PayeeContactTabsType.All].grandTotalCount &&
            state[PayeeContactTabsType.All].grandTotalCount + 1,
        },
        [PayeeContactTabsType.Suppliers]: {
          ...state[PayeeContactTabsType.Suppliers],
          grandTotalCount:
            state[PayeeContactTabsType.Suppliers].grandTotalCount &&
            state[PayeeContactTabsType.Suppliers].grandTotalCount + 1,
        },
      };
    case StoreActionType.AddCustomerSuccess:
      return {
        ...state,
        [PayeeContactTabsType.All]: {
          ...state[PayeeContactTabsType.All],
          grandTotalCount:
            state[PayeeContactTabsType.All].grandTotalCount &&
            state[PayeeContactTabsType.All].grandTotalCount + 1,
        },
        [PayeeContactTabsType.Customers]: {
          ...state[PayeeContactTabsType.Customers],
          grandTotalCount:
            state[PayeeContactTabsType.Customers].grandTotalCount &&
            state[PayeeContactTabsType.Customers].grandTotalCount + 1,
        },
      };
    case StoreActionType.Reset:
      return { ...initialState };
    default:
      return state;
  }
};

/**
 * Redux store. Allows to store React state outside of component
 * to preserve component state between navigations to other pages
 */
const store = createStore(reducer, initialState);

const selectContactsState = (state: State, contactType: PayeeContactTabsType) => state[contactType];

export { StoreActionType, selectContactsState };
export default store;
